module.exports = "/assets/data/0493b619c554ae0efaac84a9551a7adc-GL55.data.json";